import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import priceFormatter from "@/utility/priceFormatter";
import Variable from "../Variable.vue";
export default Vue.extend({
    components: { Variable },
    props: {
        salaryRow: {},
        salaryRowDetails: {},
    },
    data() {
        return {
            headers: [
                {
                    text: "Calculation basis",
                    value: "description",
                    sortable: false,
                },
                {
                    text: "Value",
                    value: "value",
                    align: "right",
                    sortable: false,
                },
            ],
        };
    },
    filters: {},
    methods: {
        ...mapActions("variableSalaryModal", ["setHoveredVariable"]),
        hoveredClass(target) {
            if (target === this.hoveredVariable) {
                return "hovered";
            }
        },
        toSek(number) {
            return priceFormatter.fromNumber(number).toStringSEK() || 0;
        },
    },
    computed: {
        ...mapGetters("variableSalaryModal", ["hoveredVariable"]),
        items() {
            return [
                {
                    description: "Billable hours in month",
                    value: `${this.salaryRowDetails.availableHours} h`,
                },
                {
                    description: "Additions",
                    value: this.toSek(this.salaryRow.additions),
                },
                {
                    description: "Team occupancy",
                    value: `${Math.round(this.salaryRowDetails.occupancyRateAverage * 100)}%`,
                },
                {
                    description: "Team size",
                    value: this.salaryRowDetails.teamSize,
                },
                {
                    description: "Salary adjustment",
                    value: this.salaryRowDetails.variableSalaryAdjustment,
                },
                {
                    description: "Long term absence",
                    value: `${this.salaryRowDetails.longTermAbsenceHours} h`,
                },
                {
                    description: "Team salary",
                    value: this.toSek(this.salaryRowDetails.teamSalary),
                },
            ];
        },
    },
});
